import styled from 'styled-components';

export const StyledHeaderV2 = styled.div`
    position: sticky;
    top: 0;
    z-index: 3;
    height: 80px;
    padding-block: 15px;
    background-image: ${(props: any) => props.backgroundImage};
    font-family: ${(props: any) => props.fontFamily};
` as any;


export const HeaderItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  > * {
    height: 100%;
  }

  .profileContainer {
    cursor: pointer;
    height: 36px;
    aspect-ratio: 1/1;
    align-items: center;

    .frame {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      aspect-ratio: 1/1;
      border-radius: 50%;
    }

    img,
    div {
      height: 90%;
      aspect-ratio: 1/1;
      border-radius: 50%;
      background-color: gray;
    }
  }
  
  .logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
  }

  img {
    max-height: 36px;
  }
  
  .logo__badge {
    padding-block: 6px;
  }


  @media only screen and (max-width: 864px) {
    padding-inline: 8px;
  }

  @media only screen and (min-width: 864px) {
    max-width: 864px;
  }

  @media only screen and (min-width: 1024px) {

  }

  @media only screen and (min-width: 1280px) {
    max-width: 1248px;
  }
` as any;